const DIA_MS = 24 * 60 * 60 * 1000;

/** `YYYY-MM-DD` (ou ISO com hora) → data local à meia-noite; `null` quando não é data. */
export function paraData(iso: string | null | undefined): Date | null {
  const partes = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso ?? "");
  if (!partes) return null;
  const [, ano = "", mes = "", dia = ""] = partes;
  return new Date(Number(ano), Number(mes) - 1, Number(dia));
}

/** `15/06/27`. */
export function formatarData(data: Date): string {
  const dois = (valor: number) => String(valor).padStart(2, "0");
  return `${dois(data.getDate())}/${dois(data.getMonth() + 1)}/${String(data.getFullYear()).slice(2)}`;
}

/** Dias entre duas datas locais; as horas e a troca de horário de verão não contam. */
export function diasEntre(inicio: Date, fim: Date): number {
  const utc = (data: Date) => Date.UTC(data.getFullYear(), data.getMonth(), data.getDate());
  return Math.round((utc(fim) - utc(inicio)) / DIA_MS);
}

export function somarDias(data: Date, dias: number): Date {
  return new Date(data.getFullYear(), data.getMonth(), data.getDate() + dias);
}

export function diasDoPeriodo(inicio: Date, fim: Date): number {
  return diasEntre(inicio, fim) + 1;
}

/** Duração original do Escopo em dias; sem as duas datas, zero (o término começa igual ao início). */
export function duracaoDoEscopo(inicio: string | null, fim: string | null): number {
  const dataInicio = paraData(inicio);
  const dataFim = paraData(fim);
  return dataInicio && dataFim ? Math.max(0, diasEntre(dataInicio, dataFim)) : 0;
}
